module.exports = __webpack_public_path__ + "media/images/congratulations-c46383b8433ca7bf103edfe2ce363343.svg";